export default "__VITE_ASSET__C2kUilyU__"